import { ParametrosGetPrevisaoVendas } from '@core/services/vendas.interface';
import {Filters} from '../previsao-vendas.models'

interface OtherParams {
  anoMesInicial: number;
  anoMesFinal: number;
  idSetorComC: number;
  page: number;
  limit: number;
}

export class GetPrevisaoVendasParamsService{
  execute(filters: Filters, otherParams: OtherParams){
    const {
      anoMesInicial,
      anoMesFinal,
      idSetorComC,
      page,
      limit
    } = otherParams;

    const params: ParametrosGetPrevisaoVendas = {
      anoMesInicial,
      anoMesFinal,
      idSetorComC: idSetorComC,
      page,
      limit
    }

    if(filters.uf){
      params.idUf = filters.uf.idUf;
    }

    if(filters.cidade){
      params.idMunic = filters.cidade.idMunic;
    }

    if(filters.bairro){
      params.nomeBairro = filters.bairro;
    }

    if(filters.statusPrevisao){
      params.flagPrevisao = filters.statusPrevisao;
    }

    if(filters.razaoSocialOuCnpj){
      const mascaraCnpjRegex = /\.|\-|\//g;
      const possivelCnpj = filters.razaoSocialOuCnpj.replace(mascaraCnpjRegex, "");
      const isCnpj = !!Number(possivelCnpj);

      if(isCnpj){
        params.razaoSocialOuCnpj = possivelCnpj;
      }else{
        params.razaoSocialOuCnpj = filters.razaoSocialOuCnpj;
      }
    }

    if(!filters.clientesProspecao){
      params.IdTipoComCDiferenteDe = 31;
    }

    return params;
  }
}
